import { z } from 'zod';
import { zLookup } from '@/utils/zodHelper';
import { NncSchema } from '@/apps/nnc/schemas/nnc';

export const AnalysisSchema = z.object({
  id: z.number().optional(),
  reference_number: z.string().optional(),
  created_at: z.string().optional(),
  created_by: zLookup().optional(),
  comment_general: z.string().optional(),
  failure_causes: z
    .array(
      z.object({
        origin: zLookup().optional(),
        cause: zLookup().optional(),
        comment: z.string().optional(),
      }),
    )
    .optional(),
  nnc: z.array(NncSchema).optional(),
});

export const AnalysisSearchSchema = z.object({
  start_date: z.date(),
  end_date: z.date(),
  country: zLookup(),
  unit: zLookup(),
  status: zLookup(),
});

export type AnalysisSchemaType = z.infer<typeof AnalysisSchema>;
export type AnalysisSearchSchemaType = z.infer<typeof AnalysisSearchSchema>;
